import React from 'react';
import {useRouter} from 'next/router';

import CoursePage from '../../../js/pages/CoursePage';
import {useAppContext} from '../../../js/hooks';

export default function Page() {
  const router = useRouter();
  const {courseOrTrack} = router.query;
  const {loading} = useAppContext();

  return loading ? null : <CoursePage courseSlug={courseOrTrack} />;
}
